import { render, staticRenderFns } from "./AboutShopping.vue?vue&type=template&id=cabeb216&"
import script from "./AboutShopping.vue?vue&type=script&lang=js&"
export * from "./AboutShopping.vue?vue&type=script&lang=js&"
import style0 from "./AboutShopping.vue?vue&type=style&index=0&id=cabeb216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports